import { useMutation } from '@tanstack/react-query';

import { phoneRegisterApi } from '../api';

export default function useRegisterPhoneMutation(config?: any) {
  return useMutation(phoneRegisterApi, config);
}
